export default "__VITE_ASSET__C134WQo2__"